<desy-card
  classes="w-1/3"
  [containerClasses]="'p-base border-2 mb-4 w-[1200px] lg:min-w-0 custom-card-width border-neutral-light '">
  <div class="text-sm flex w-[100%] custom-card-width--100">
    <div class="flex flex-col w-[80%]">
      <h5 class="text-base font-bold">{{ title }}</h5>
      <span class="mt-2">{{ subtitle }}</span>
      @if (description) {
        <div>
          <desy-details summaryText="Ver descripción">{{ description }}</desy-details>
        </div>
      }
    </div>
    <div class="flex justify-around w-[20%]">
      <a
        class="text-primary-base mt-2 underline"
        *ngIf="urlDetail"
        href="{{ urlDetail }}">
        Ir a detalle
      </a>
      @if (actions.length) {
        @for (a of actions; track a.label) {
          @if (a.type === 'link') {
            <desy-button
              (clickEvent)="a.action()"
              classes="c-button c-button--transparent c-button--sm ng-star-inserted mr-[5px]">
              {{ a.label }}
            </desy-button>
          }
          @if (a.type === 'button') {
            <desy-button
              (clickEvent)="a.action()"
              classes="c-button c-button--sm ng-star-inserted">
              {{ a.label }}
            </desy-button>
          }
        }
      }
    </div>
  </div>
</desy-card>
